import { PaperFileIcon } from 'components/icons/PaperFileIcon';
import { WorldEarthIcon } from 'components/icons/WorldEarthIcon';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface IResource {
  topSectionHeight?: number;
  external?: boolean;
}

function Resources({ topSectionHeight, external }: IResource) {
  const resourceData = useSelector((state: RootState) => state.resources.resource);

  return (
    <div className={`${topSectionHeight ? '' : 'border'} p-4 h-auto mr-3 rounded-md w-full md:w-96 text-black text-sm`}>
      {external ? (
        <>
          {topSectionHeight ? '' : <p className="font-bold text-base mb-2">Resources</p>}
          {(resourceData || []).map((resource: any) => (
            <a
              className="flex items-center"
              href={resource.file || resource.link}
              target="_blank"
              rel="noreferrer"
              key={resource.hash_id}
            >
              {resource.resource_type === 'file' && <PaperFileIcon className="w-4 h-4" />}
              {resource.resource_type === 'link' && <WorldEarthIcon className="w-4 h-4" />}
              <p className="p-2">{resource.title}</p>
            </a>
          ))}
        </>
      ) : (
        <PerfectScrollbar
          style={{
            maxHeight: topSectionHeight ? `calc(100vh - ${topSectionHeight + 75}px)` : `calc((100vh - 350px) / 2)`
          }}
        >
          <p className="font-bold text-base mb-2">Resources</p>
          {(resourceData || []).map((resource: any) => (
            <a
              className="flex items-center"
              href={resource.file || resource.link}
              target="_blank"
              rel="noreferrer"
              key={resource.hash_id}
            >
              {resource.resource_type === 'file' && <PaperFileIcon className="w-4 h-4" />}
              {resource.resource_type === 'link' && <WorldEarthIcon className="w-4 h-4" />}
              <p className="p-2">{resource.title}</p>
            </a>
          ))}
        </PerfectScrollbar>
      )}
    </div>
  );
}

export default memo(Resources);
